export function QBOSupportCtrl ($http, $uibModal, $scope, $window, confirm, messages, workshopAPI, QBOSupport, AdminDashboard) {

  var ref_id = ''

  $scope.QBOSupport = new QBOSupport();
  $scope.AdminDashboard = new AdminDashboard();

  workshopAPI.get('/workshop_admin/supportTypes').then(function (data) {
    $scope.record_type_list = data.qbo_record_types;
    $scope.qbo_contact_type_list = data.qbo_contact_types;
  });

  $scope.retrieve_record_by_id = {
    id: ref_id || '',
    record_type: '',
    run: function() {
      workshopAPI.get('/quickbooks_online/retrieve_record_by_id', [$scope.company.id, this.record_type, this.id]).then(function (data) {
        $scope.record = data;
      }).then(function() {
        return $scope.QBOSupport.retrieve_record_by_id($scope.record, this.record_type);
      }, function (err) {
        messages.error(err);
      });
    },
    get_id: function() {
      return $scope.AdminDashboard.get_id_for_support($scope.company).then(function(data) {
          $scope.retrieve_record_by_id.id = data.record.id;
          $scope.retrieve_record_by_id.record_type = data.type;
      })

    }
  };

  $scope.clear_all_non_existing_contacts = {
    contact_type: '',
    run: function() {
      workshopAPI.get('/quickbooks_online/clear_all_non_existing_contacts', [$scope.company.id, this.contact_type]).then(function (result) {
        return $scope.QBOSupport.clear_all_non_existing_contacts(result);
      }, function (err) {
        messages.error(err);
      });
    }
  };

  $scope.clear_duplicates = {
    run: function() {
      workshopAPI.get('/quickbooks_online/clear_duplicates', [$scope.company.id]).then(function (result) {
        return $scope.QBOSupport.clear_duplicates(result);
      }, function (err) {
        messages.error(err);
      });
    }
  };

  $scope.check_contacts_match_and_clear = {
    contact_type: '',
    run: function() {
      workshopAPI.get('/quickbooks_online/check_contacts_match_and_clear', [$scope.company.id, this.contact_type]).then(function (result) {
        return $scope.QBOSupport.check_contacts_match_and_clear(result);
      }, function (err) {
        messages.error(err);
      });
    }
  };

  $scope.view_batch_object = {
    record_type: '',
    attempt_upload: false,
    run: function() {
      workshopAPI.get('/quickbooks_online/view_batch_object', [$scope.company.id, this.record_type, this.attempt_upload]).then(function (result) {
        return $scope.QBOSupport.view_batch_object(result);
      }, function (err) {
        messages.error(err);
      });
    }
  };

  $scope.find_product_by_name = {
    product_id: '',
    run: function() {
      workshopAPI.get('/quickbooks_online/find_product_by_name', [$scope.company.id, this.product_id]).then(function (data) {
        $scope.product = data;
      }).then(function() {
        return $scope.QBOSupport.find_product_by_name($scope.product);
      }, function (err) {
        messages.error(err);
      });
    },
    get_id: function() {
      return $scope.AdminDashboard.get_id_for_support($scope.company).then(function(data) {
          $scope.find_product_by_name.product_id = data.record.id;
      })

    }
  };
    
}